import React from 'react';
import { motion } from 'framer-motion';
import { Button } from "../../components/ui/button"; // Adjust path
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card"; // Adjust path

const LandingPage: React.FC = () => {
  // Animation variants for Framer Motion
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    },
  };

  return (
    <div className="container mx-auto px-4 py-16 text-center">
      {/* Hero Section - can be extracted to a separate component */}
      <motion.div initial="hidden" animate="visible" variants={cardVariants}>
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-foreground">
          Welcome to Schwinghub Portfolio
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Showcasing projects, skills, and integrated web applications. Explore the Goal Planner or learn more about my work.
        </p>
        <motion.div 
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
        >
          <Button size="lg" asChild>
            {/* Link this button appropriately later, maybe to /login or /dashboard */}
            <a href="/login">Get Started</a> 
          </Button>
        </motion.div>
      </motion.div>

      {/* App Showcase Section - can be extracted */}
      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={cardVariants}>
           <Card className="text-left">
            <CardHeader>
              <CardTitle>Goal Planner App</CardTitle>
              <CardDescription>Manage your goals and daily tasks effectively.</CardDescription>
            </CardHeader>
            <CardContent>
              <p>Set hierarchical goals, track daily tasks, and build consistent habits with gamification features like streaks and activity heatmaps.</p>
            </CardContent>
            <CardFooter>
              <Button asChild variant="outline">
                <a href="/login">Access App</a>{/* Or link to /app/goals if logged in */}
              </Button>
            </CardFooter>
          </Card>
        </motion.div>
        
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={cardVariants} transition={{ delay: 0.1 }}>
          <Card className="text-left">
            <CardHeader>
              <CardTitle>About Me</CardTitle>
              <CardDescription>Learn more about my skills and experience.</CardDescription>
            </CardHeader>
            <CardContent>
              <p>Visit my LinkedIn profile to see my professional background, connect, or discuss potential opportunities.</p>
            </CardContent>
            <CardFooter>
              <Button asChild variant="secondary">
                <a href="https://www.linkedin.com/in/andreas-schwing-8850519a" target="_blank" rel="noopener noreferrer">LinkedIn Profile</a>
              </Button>
            </CardFooter>
          </Card>
        </motion.div>
      </div>

    </div>
  );
};

export default LandingPage; 